import {
	EndorsementExposureUpdateRequest,
	EndorsementUpdateRequest,
} from '../../../types/endorsements';
import { PerilUpdateRequest } from '../../../types/policy';
import {
	RenewalExposureUpdateRequest,
	RenewalUpdateRequest,
} from '../../../types/renewals';

const filterRemovedFieldGroups = (
	object:
		| PerilUpdateRequest
		| RenewalUpdateRequest
		| RenewalExposureUpdateRequest
		| EndorsementUpdateRequest
		| EndorsementExposureUpdateRequest,
) => {
	if (
		object.removeFieldGroups?.length > 0 &&
		object.updateFieldGroups?.length > 0
	) {
		object.updateFieldGroups = object.updateFieldGroups.filter((fg: any) => {
			return !object.removeFieldGroups.includes(fg.fieldGroupLocator);
		});
	}
};

const filterEndedExposures = (
	updateObject: RenewalUpdateRequest | EndorsementUpdateRequest,
) => {
	if (
		updateObject.endExposures?.length > 0 &&
		updateObject.updateExposures?.length > 0
	) {
		updateObject.updateExposures = updateObject.updateExposures.filter(
			(exposure: any) => {
				return !updateObject.endExposures.includes(exposure.exposureLocator);
			},
		);
	}
};

const filterEmptyUpdateExposures = (
	updateObject: RenewalUpdateRequest | EndorsementUpdateRequest,
) => {
	if (updateObject.updateExposures?.length > 0) {
		updateObject.updateExposures = updateObject.updateExposures.filter(
			(
				exposure:
					| EndorsementExposureUpdateRequest
					| RenewalExposureUpdateRequest,
			) => {
				return (
					(exposure.addFieldGroups ?? []).length > 0 ||
					(exposure.addPerils ?? []).length > 0 ||
					(exposure.endPerils ?? []).length > 0 ||
					Object.keys(exposure.fieldValues ?? {}).length > 0 ||
					(exposure.removeFieldGroups ?? []).length > 0 ||
					(exposure.updateFieldGroups ?? []).length > 0 ||
					(exposure.updatePerils ?? []).length > 0
				);
			},
		);
	}
};

const filterEndedPerils = (
	updateExposure:
		| RenewalExposureUpdateRequest
		| EndorsementExposureUpdateRequest,
) => {
	if (
		updateExposure.endPerils?.length > 0 &&
		updateExposure.updatePerils?.length > 0
	) {
		updateExposure.updatePerils = updateExposure.updatePerils.filter(
			(peril: any) => {
				return !updateExposure.endPerils.includes(peril.perilLocator);
			},
		);
	}
};

const filterRemovedFromUpdated = (
	updateObject: RenewalUpdateRequest | EndorsementUpdateRequest,
) => {
	const filteredObject = { ...updateObject };
	// delete remove field groups and end exposures from base updateObj
	filterRemovedFieldGroups(filteredObject);
	filterEndedExposures(filteredObject);
	// remove any update exposures that are empty (have no updates)
	filterEmptyUpdateExposures(filteredObject);

	filteredObject.updateExposures?.forEach(
		(
			exposure: RenewalExposureUpdateRequest | EndorsementExposureUpdateRequest,
		) => {
			// delete remove field groups and end perils from each updated exposure
			filterRemovedFieldGroups(exposure);
			filterEndedPerils(exposure);

			// delete remove field groups from each updated peril on updated exposure
			exposure.updatePerils?.forEach((peril: PerilUpdateRequest) => {
				filterRemovedFieldGroups(peril);
			});
		},
	);
	return filteredObject;
};

export default filterRemovedFromUpdated;
